import React from 'react';
import { FieldRenderer } from '../fieldRegistry';
import { DescriptionField } from './DescriptionField';

export const renderDescriptionField: FieldRenderer = (
  field,
  formState,
  updateFormState
) => {
  const isRequired = field.validation?.type === 'required';
  return (
    <DescriptionField
      key={field.name}
      value={(formState[field.name] as string) || ''}
      onChange={(value: string) =>
        updateFormState(prev => ({ ...prev, [field.name]: value }))
      }
      maxLength={field.maxLength}
      placeholder={field.placeholder}
      required={isRequired}
    />
  );
};
